/* eslint-disable */
import { xenv, xenvActionFactory } from '../xenv';
import { webappXenv } from '../xenv/webappXenv';
import { build, query, hashQuery, parseURL, buildSearch } from '../query';
import { getNineChapterShareParams } from '../statistic';
import { alimpSetShare, alimpDisableShare, alimpInvokeShare, alipayInvokeShare, 
// bdmpShare,
// cowxmpShare,
sfcwxmpSetShare, sfcwxmpInvokeShare, sfcalimpSetShare, sfcalimpInvokeShare, driverSetShare, driverInvokeShare, 
// driverShare,
// drwxmpShare,
// gjwxmpShare,
gaswxmpSetShare, gaswxmpInvokeShare, 
// h5Share,
// kfalimpShare,
kfdriverSetShare, kfdriverInvokeShare, 
// kfdwxmpShare,
kfpassengerSetShare, kfpassengerInvokeShare, kfwxmpSetShare, kfwxmpInvokeShare, 
// mqqShare,
passengerSetShare, passengerDisableShare, passengerInvokeShare, qjwxmpSetShare, qjwxmpInvokeShare, 
// qqmpShare,
// thwxmpShare,
weixinSetShare, weixinDisableShare, weixinInvokeShare, wxmpSetShare, wxmpDisableShare, wxmpInvokeShare, dympSetShare, dympInvokeShare, yxwxmpSetShare, yxwxmpInvokeShare, hitchappSetShare, hitchappInvokeShare, hywxmpSetShare, hywxmpInvokeShare, hyalimpSetShare, hyalimpInvokeShare, crwxmpSetShare, crwxmpInvokeShare, cralimpSetShare, cralimpInvokeShare, cralimpDisableShare, eshwxmpSetShare, eshwxmpInvokeShare, hypassengerSetShare, hypassengerInvokeShare, 
// hwfastappSetShare,
hwfastappInvokeShare } from '../platform/xenv';
import { utils } from '../utils';
const currentUrl = window.location.href;
const urlParams = Object.assign({}, query(currentUrl), hashQuery(currentUrl));
export const channelMapping = {
    wx_appmsg: {
        // 微信好友
        API: 'shareWeixinAppmsg'
    },
    wx_timeline: {
        // 微信朋友圈
        API: 'shareWeixinTimeline'
    },
    ali_appmsg: {
        // 支付宝好友
        API: 'shareAlipayFriend'
    },
    ali_timeline: {
        // 支付宝朋友圈
        API: 'shareAlipayLife'
    },
    qq_appmsg: {
        // QQ好友
        API: 'shareQqAppmsg'
    },
    qzone: {
        // QQ空间
        API: 'shareQzone'
    },
    dcommand: {
        // didi口令
        API: 'shareWeixinKouling'
    },
    dy_appmsg: {
        // 抖音好友
        API: 'shareDouyinAppmsg'
    },
};
const getXenvConfig = (config) => {
    if (Array.isArray(config)) {
        const target = config.find((item) => {
            return (Object.prototype.toString.call(item) === '[object Object]' &&
                item.xenv === xenv());
        });
        return target;
    }
};
/* 整理Fusion相关分享配置 */
const formatFusionSetShareConfig = (common, channels) => {
    let buttons = [];
    let result = { buttons };
    Object.entries(channels).forEach(([channel, channelConfig]) => {
        const xenvConfig = getXenvConfig(channelConfig);
        if (!xenvConfig || !xenvConfig.xenv)
            return;
        let currentConfig = {
            type: 'shareWeixinAppmsg',
            data: {
                type: 'text',
                title: '',
                icon: '',
                content: '',
                url: ''
            }
        };
        currentConfig['type'] =
            channelMapping[channel] && channelMapping[channel].API;
        let exhaustiveCheck;
        switch (xenvConfig.share_type) {
            case 'text':
                currentConfig['data'] = {
                    type: 'text',
                    title: common.title,
                    content: common.desc,
                    icon: common.icon,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common))
                };
                break;
            case 'image':
                currentConfig['data'] = {
                    type: 'image',
                    image: common.poster_url,
                    content: xenvConfig.content || ''
                };
                break;
            case 'miniApp':
                currentConfig['data'] = {
                    type: 'miniApp',
                    title: common.card_content,
                    content: common.desc,
                    icon: common.img_url,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                    ext: {
                        path: build(xenvConfig.path, { ...getNineChapterShareParams(common), appid: undefined }),
                        appId: xenvConfig.appid,
                        programType: xenvConfig.miniprogram_type || 0,
                        miniprogramType: xenvConfig.miniprogram_type || 0
                    }
                };
                break;
            case 'dcommand':
                currentConfig['data'] = {
                    type: 'dcommand',
                    dcommand_content: common.dcommand_text
                };
                break;
            default:
                exhaustiveCheck = xenvConfig;
        }
        buttons.push(currentConfig);
    });
    const refreshButton = {
        type: 'refreshPage',
        data: {}
    };
    buttons.push(refreshButton);
    result.buttons = buttons;
    return result;
};
/* 整理Fusion相关分享配置 */
const formatFusionInvokeShareConfig = (common, channels) => {
    if (Object.keys(channels).length > 1) {
        /* 传入多个渠道 进入拉起分享面板逻辑 */
        return formatFusionSetShareConfig(common, channels);
    }
    else {
        const [channel, targetChannel] = Object.entries(channels)[0];
        const xenvConfig = getXenvConfig(targetChannel);
        if (!xenvConfig || !xenvConfig.xenv)
            return;
        let currentConfig = {
            type: 'text',
            title: '',
            icon: '',
            content: '',
            url: ''
        };
        const channelName = channelMapping[channel] && channelMapping[channel].API;
        let exhaustiveCheck;
        switch (xenvConfig.share_type) {
            case 'text':
                currentConfig = {
                    channel: channelName,
                    type: 'text',
                    title: common.title,
                    content: common.desc,
                    icon: common.icon,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common))
                };
                break;
            case 'image':
                currentConfig = {
                    channel: channelName,
                    type: 'image',
                    image: common.poster_url,
                    content: xenvConfig.content || ''
                };
                break;
            case 'miniApp':
                currentConfig = {
                    channel: channelName,
                    type: 'miniApp',
                    title: common.card_content,
                    content: common.desc,
                    icon: common.img_url,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                    ext: {
                        path: build(xenvConfig.path, { ...getNineChapterShareParams(common), appid: undefined }),
                        appId: xenvConfig.appid,
                        programType: xenvConfig.miniprogram_type || 0,
                        miniprogramType: xenvConfig.miniprogram_type || 0
                    }
                };
                console.log('=== xpos_share ===', common, getNineChapterShareParams(common));
                console.log('=== cuurentConfig ===', currentConfig);
                break;
            case 'dcommand':
                currentConfig = {
                    channel: channelName,
                    type: 'dcommand',
                    dcommand_content: common.dcommand_text
                };
                break;
            default:
                exhaustiveCheck = xenvConfig;
        }
        return currentConfig;
    }
};
/* 整理微信web环境分享配置 */
const formatWeixinWebShareConfig = (common, channels) => {
    let result = [];
    const targets = ['wx_appmsg', 'wx_timeline'];
    Object.entries(channels).forEach(([channel, channelConfig]) => {
        if (targets.includes(channel)) {
            const xenvConfig = getXenvConfig(channelConfig);
            if (!xenvConfig || !xenvConfig.xenv)
                return;
            switch (channel) {
                case 'wx_appmsg':
                    if (xenvConfig.share_type === 'text' ||
                        xenvConfig.share_type === 'miniApp') {
                        result.push({
                            type: 'wx_appmsg',
                            title: common.title,
                            desc: common.desc,
                            link: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                            imgUrl: common.icon
                        });
                    }
                    break;
                case 'wx_timeline':
                    if (xenvConfig.share_type === 'text' ||
                        xenvConfig.share_type === 'miniApp') {
                        result.push({
                            type: 'wx_timeline',
                            title: common.title,
                            link: build(filtrateParams(xenvConfig.link), getNineChapterShareParams(common)),
                            imgUrl: common.icon
                        });
                    }
                    break;
            }
        }
    });
    return result;
};
/* 整理微信小程序webview环境分享配置 */
const formatWebviewShareConfig = (env, common, channels) => {
    const channelsConfigMap = {
        wx: 'wx_appmsg',
        ali: 'ali_appmsg',
        dy: 'dy_appmsg'
    };
    let targetChannelConfig = channels[channelsConfigMap[env]];
    if (env === 'ali') {
        // 担心写死了wx_appmsg渠道的项目出问题，故仅维持ali环境下的兜底逻辑
        // 后续新增env，理论上不会做任何兜底
        targetChannelConfig = targetChannelConfig || channels.wx_appmsg;
    }
    const xenvConfig = getXenvConfig(targetChannelConfig);
    if (!xenvConfig)
        return;
    if (xenvConfig.share_type !== 'miniApp')
        return; // 微信小程序webview 只能设置分享小程序
    /* 区分微信/支付宝/抖音小程序 分别传入对应的config */
    switch (env) {
        case 'wx':
            /* 微信小程序环境下 */
            const wechatWebviewConfig = {
                type: 'share',
                data: {
                    title: common.card_content,
                    imageUrl: common.img_url,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                    mpPath: build(filtrateParams(xenvConfig.path), getNineChapterShareParams(common), xenv() === 'yxwxmp')
                }
            };
            if (urlParams['xwebapp']) {
                // 滴滴出行小程序webview环境
                const wechatShortConfig = {
                    data: wechatWebviewConfig
                };
                return wechatShortConfig;
            }
            else {
                // 其他环境
                const wechatLongConfig = {
                    data: {
                        path: build(filtrateParams(xenvConfig.path), getNineChapterShareParams(common), xenv() === 'yxwxmp'),
                        title: common.card_content,
                        imageUrl: common.img_url,
                        ...wechatWebviewConfig
                    }
                };
                return wechatLongConfig;
            }
        case 'ali':
            const aliWebviewConfig = {
                type: 'share',
                data: {
                    title: common.ali_title,
                    desc: common.ali_desc,
                    content: common.ali_content,
                    imageUrl: common.ali_image_url,
                    bgImgUrl: common.ali_bg_img_url,
                    scImgUrl: common.ali_sc_img_url,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                    mpPath: build(filtrateParams(xenvConfig.path), getNineChapterShareParams(common), xenv() === 'yxwxmp')
                }
            };
            const aliShortConfig = {
                data: aliWebviewConfig
            };
            return aliShortConfig;
        case 'dy':
            /* 抖音小程序环境下 */
            const douyinWebviewConfig = {
                type: 'share',
                data: {
                    title: common.dy_title,
                    desc: common.dy_desc,
                    imageUrl: common.dy_image_url,
                    templateId: common.dy_template_id,
                    url: build(filtrateParams(xenvConfig.link || window.location.href), getNineChapterShareParams(common)),
                    mpPath: build(filtrateParams(xenvConfig.path), getNineChapterShareParams(common))
                }
            };
            if (urlParams['dywebapp']) {
                // 抖音营销小程序webview环境
                const douyinShortConfig = {
                    data: douyinWebviewConfig
                };
                return douyinShortConfig;
            }
            else {
                // 其他环境
                const douyinLongConfig = {
                    data: {
                        path: build(filtrateParams(xenvConfig.path), getNineChapterShareParams(common)),
                        title: common.dy_title,
                        desc: common.dy_desc,
                        imageUrl: common.dy_image_url,
                        ...douyinWebviewConfig
                    }
                };
                return douyinLongConfig;
            }
    }
};
/* 整理微信小程序中间页分享配置 */
const formatTransitionPageShareConfig = (common, channels, mpShareConfig) => {
    const configList = channels['wx_appmsg'];
    const xenvConfig = getXenvConfig(configList);
    // hwfastapp 只有一种分享类型H5
    if (!xenvConfig || (!webappXenv.includes(xenv()) && xenvConfig.share_type !== 'miniApp'))
        return;
    const targetUrl = {
        'miniApp': 'path',
        'text': 'link',
        'wx_h5': 'link'
    }[xenvConfig.share_type];
    const extraParams = omit(mpShareConfig.extra, mpShareConfigExtraIgnoreList);
    let result = {
        ...extraParams,
        activity_id: mpShareConfig.activity_id || common.activity_id,
        bs_id: mpShareConfig.bs_id || common.bs_id || '',
        share_title: mpShareConfig.share_title,
        share_tip_title: mpShareConfig.share_tip_title,
        share_subTitle: mpShareConfig.share_subTitle || common.desc,
        share_imgUrl: mpShareConfig.share_imgUrl,
        share_shareTitle: mpShareConfig.share_shareTitle || common.card_content || '滴滴出行',
        share_sharePath: mpShareConfig.share_sharePath
            ? encodeURIComponent(build(decodeURIComponent(filtrateParams(mpShareConfig.share_sharePath)), getNineChapterShareParams(common)))
            : encodeURIComponent(build(filtrateParams(xenvConfig[targetUrl]), getNineChapterShareParams(common), xenv() === 'yxwxmp')),
        share_shareImgUrl: mpShareConfig.share_shareImgUrl || common.img_url || 'https://ut-static.udache.com/webx/mini-pics/U7mDFxU2yh-2-r1BJ-J0X.png',
        share_share_group_btn_text: mpShareConfig.share_share_group_btn_text,
        share_share_group_btn_image: mpShareConfig.share_share_group_btn_image,
        poster_title: mpShareConfig.poster_title,
        poster_sub_title: mpShareConfig.poster_sub_title,
        poster_image_url: mpShareConfig.poster_image_url || mpShareConfig.poster_img_url || common.poster_url || '',
        poster_btn_text: mpShareConfig.poster_btn_text,
        poster_btn_image: mpShareConfig.poster_btn_image,
        other_type: mpShareConfig.other_type
    };
    return result;
};
// 分享中间页埋点参数过滤列表
const mpShareConfigExtraIgnoreList = [
    'type',
    'activity_id',
    'bs_id',
    'share_title',
    'share_tip_title',
    'share_subTitle',
    'share_imgUrl',
    'share_shareTitle',
    'share_sharePath',
    'share_shareImgUrl',
    'share_share_group_btn_text',
    'share_share_group_btn_image',
    'poster_title',
    'poster_sub_title',
    'poster_img_url',
    'poster_image_url',
    'poster_btn_text',
    'poster_btn_image',
    'other_type',
];
// 过滤指定属性
const omit = (originObj, ignoreList) => {
    if (!utils.isObj(originObj))
        return {};
    const obj = utils.cloneDeep(originObj);
    for (let key in obj) {
        if (ignoreList.includes(key)) {
            delete obj[key];
        }
    }
    return obj;
};
// 分享url过滤参数列表
const urlIgnoreList = [
    'token',
    'cityid',
    'city_id',
    'cityId',
    'lat',
    'lng',
    'openid',
    'appid',
    'from',
    'lang',
];
// 过滤跳转url参数
const filtrateParams = (url) => {
    const decode = parseURL(url);
    if (decode.search) {
        const searchMap = query(url);
        urlIgnoreList.forEach(key => {
            if (searchMap[key])
                delete searchMap[key];
            if (searchMap.url) {
                searchMap.url = encodeURIComponent(decodeURIComponent(searchMap.url));
            }
        });
        decode.search = buildSearch(searchMap, false);
    }
    console.log('处理后参数打印', decode.protocol + decode.hostAndPath + decode.search + decode.hash);
    return decode.protocol + decode.hostAndPath + decode.search + decode.hash;
};
/* 格式化setShare参数 */
const formatSetShareConfig = (config) => {
    let result = {};
    const prev = { title: '', desc: '', icon: '', img_url: '' };
    const commonConfig = Object.entries(config).reduce((obj, [key, content]) => {
        if (key !== 'channels')
            obj[key] = content;
        return obj;
    }, prev);
    const channels = config.channels || {};
    const currentXenv = xenv();
    let exhaustiveCheck;
    switch (currentXenv) {
        case 'hitchapp':
        case 'hypassenger': // 滴滴货运独立App
        case 'passenger': // 滴滴出行乘客端App
        case 'kfpassenger': // 花小猪乘客端App
        case 'driver': // 司机端App
        case 'kfdriver': // 花小猪司机端App
            /* 各业务线乘客端format参考fusion */
            result = formatFusionSetShareConfig(commonConfig, channels);
            break;
        case 'esapp': // 企业级app
            break;
        case 'hydriver': // 货运司机app
            break;
        case 'weixin': // 微信web环境
            result = formatWeixinWebShareConfig(commonConfig, channels);
            break;
        case 'alipay': // 支付宝web环境
            break;
        case 'mqq': // QQweb环境
            break;
        case 'bdmp':
        case 'cowxmp':
        case 'sfcwxmp':
        case 'drwxmp':
        case 'gjwxmp':
        case 'kfdwxmp':
        case 'kfwxmp':
        case 'thwxmp':
        case 'qjwxmp':
        case 'qqmp':
        case 'wxmp':
        case 'yxwxmp':
        case 'gaswxmp':
        case 'hywxmp':
        case 'eshwxmp':
        case 'crwxmp':
            /* 微信小程序webview环境 */
            result = formatWebviewShareConfig('wx', commonConfig, channels); // setShare时针对webview环境
            break;
        case 'alimp': // 滴滴出行支付宝小程序
        case 'kfalimp': // 花小猪支付宝小程序
        case 'sfcalimp': // 顺风车支付宝小程序
        case 'cralimp': // 滴滴租车支付宝小程序
        case 'hyalimp': // 货运支付宝小程序
            /* 支付宝小程序webview环境 */
            result = formatWebviewShareConfig('ali', commonConfig, channels); // setShare时针对webview环境
            break;
        case 'dymp': // 抖音小程序
            /* 抖音小程序webview环境 */
            result = formatWebviewShareConfig('dy', commonConfig, channels); // setShare时针对webview环境
            break;
        case 'h5': // 第三方web环境
        case 'hwfastapp': // 华为快应用webapp
            break;
        default:
            exhaustiveCheck = currentXenv; // 利用ts类型检测 判断枚举值是否已被穷举
    }
    console.log('[formatSetShareConfig:result]', result);
    return result;
};
/* 格式化invokeShare参数 */
const formatInvokeShareConfig = (config) => {
    let result = {};
    const prev = { title: '', desc: '', icon: '', img_url: '' };
    const commonConfig = Object.entries(config).reduce((obj, [key, content]) => {
        if (key !== 'channels')
            obj[key] = content;
        return obj;
    }, prev);
    const channels = config.channels || {};
    const mpShareConfig = config.mpShareConfig || {};
    const currentXenv = xenv();
    let exhaustiveCheck;
    switch (currentXenv) {
        case 'hitchapp':
        case 'hypassenger': // 滴滴货运独立App
        case 'passenger': // 滴滴出行乘客端App
        case 'kfpassenger': // 花小猪乘客端App
        case 'driver':
        case 'kfdriver':
            /* 各业务线乘客端 format参考fusion */
            result = formatFusionInvokeShareConfig(commonConfig, channels);
            break;
        case 'esapp': // 企业级app
            break;
        case 'hydriver': // 货运司机app
            break;
        case 'weixin': // 微信web环境
            /* 蒙层兜底 */
            break;
        case 'alipay': // 支付宝web环境
            /* 蒙层兜底 */
            break;
        case 'mqq': // QQweb环境
            /* 暂不支持invokeShare */
            break;
        case 'bdmp':
        case 'cowxmp':
        case 'sfcwxmp':
        case 'drwxmp':
        case 'gjwxmp':
        case 'kfdwxmp':
        case 'kfwxmp':
        case 'thwxmp':
        case 'qjwxmp':
        case 'qqmp':
        case 'wxmp':
        case 'yxwxmp':
        case 'gaswxmp':
        case 'hywxmp':
        case 'eshwxmp':
        case 'hwfastapp':
        case 'crwxmp':
            const transitionPageCommonConfig = Object.assign(commonConfig, {
                activity_id: config.activity_id,
                bs_id: config.bs_id
            });
            /* 各业务线微信小程序webview环境 */
            result = formatTransitionPageShareConfig(transitionPageCommonConfig, channels, mpShareConfig); // invokeShare时针对小程序分享中间页
            break;
        case 'alimp':
        case 'kfalimp':
        case 'hyalimp':
        case 'sfcalimp':
        case 'cralimp':
            /* 各业务线支付宝小程序环境 暂不支持invokeShare */
            break;
        case 'dymp':
            /* 抖音小程序环境 暂不支持invokeShare */
            break;
        case 'h5':
            /* 外部H5环境 暂不支持invokeShare */
            break;
        default:
            exhaustiveCheck = currentXenv; // 利用ts类型检测 判断枚举值是否已被穷举
    }
    return result;
};
const disableShareEnv = ['passenger', 'weixin', 'wxmp', 'alimp', 'cralimp'];
const disableShare = () => {
    const xenvSetShareMapping = {
        passenger: passengerDisableShare,
        weixin: weixinDisableShare,
        wxmp: wxmpDisableShare,
        alimp: alimpDisableShare,
        cralimp: cralimpDisableShare
    };
    const fn = xenvActionFactory('setShare', xenvSetShareMapping);
    return fn();
};
const setShare = (config) => {
    if (disableShareEnv.includes(xenv()) && config.open_share === 0) {
        disableShare();
        return;
    }
    const formattedConfig = formatSetShareConfig(config);
    console.log('进入----------------------', formattedConfig);
    const xenvSetShareMapping = {
        alimp: alimpSetShare,
        // 'alipay': alipayShare,
        // 'bdmp': bdmpShare,
        // 'cowxmp': cowxmpShare,
        sfcwxmp: sfcwxmpSetShare,
        sfcalimp: sfcalimpSetShare,
        driver: driverSetShare,
        // 'drwxmp': drwxmpShare,
        // 'gjwxmp': gjwxmpShare,
        gaswxmp: gaswxmpSetShare,
        // 'h5': h5Share,
        // 'kfalimp': kfalimpShare,
        kfdriver: kfdriverSetShare,
        hitchapp: hitchappSetShare,
        // 'kfdwxmp': kfdwxmpShare,
        kfpassenger: kfpassengerSetShare,
        kfwxmp: kfwxmpSetShare,
        // 'mqq': mqqShare,
        passenger: passengerSetShare,
        qjwxmp: qjwxmpSetShare,
        // 'qqmp': qqmpShare,
        // 'thwxmp': thwxmpShare,
        weixin: weixinSetShare,
        wxmp: wxmpSetShare,
        dymp: dympSetShare,
        yxwxmp: yxwxmpSetShare,
        hywxmp: hywxmpSetShare,
        hyalimp: hyalimpSetShare,
        crwxmp: crwxmpSetShare,
        cralimp: cralimpSetShare,
        eshwxmp: eshwxmpSetShare,
        hypassenger: hypassengerSetShare
        // hwfastapp: hwfastappSetShare
    };
    const fn = xenvActionFactory('setShare', xenvSetShareMapping);
    return fn(formattedConfig);
};
const invokeShare = (config) => {
    const formattedConfig = formatInvokeShareConfig(config);
    const xenvInvokeShareMapping = {
        alimp: alimpInvokeShare,
        alipay: alipayInvokeShare,
        // 'bdmp': bdmpShare,
        // 'cowxmp': cowxmpShare,
        sfcwxmp: sfcwxmpInvokeShare,
        sfcalimp: sfcalimpInvokeShare,
        driver: driverInvokeShare,
        // 'drwxmp': drwxmpShare,
        // 'gjwxmp': gjwxmpShare,
        gaswxmp: gaswxmpInvokeShare,
        // 'h5': h5Share,
        // 'kfalimp': kfalimpShare,
        kfdriver: kfdriverInvokeShare,
        hitchapp: hitchappInvokeShare,
        // 'kfdwxmp': kfdwxmpShare,
        kfpassenger: kfpassengerInvokeShare,
        kfwxmp: kfwxmpInvokeShare,
        // 'mqq': mqqShare,
        passenger: passengerInvokeShare,
        qjwxmp: qjwxmpInvokeShare,
        // 'qqmp': qqmpShare,
        // 'thwxmp': thwxmpShare,
        weixin: weixinInvokeShare,
        wxmp: wxmpInvokeShare,
        dymp: dympInvokeShare,
        yxwxmp: yxwxmpInvokeShare,
        hywxmp: hywxmpInvokeShare,
        hyalimp: hyalimpInvokeShare,
        crwxmp: crwxmpInvokeShare,
        cralimp: cralimpInvokeShare,
        eshwxmp: eshwxmpInvokeShare,
        hypassenger: hypassengerInvokeShare,
        hwfastapp: hwfastappInvokeShare
    };
    const fn = xenvActionFactory('invokeShare', xenvInvokeShareMapping);
    return fn(formattedConfig);
};
export { setShare, invokeShare };
